<template>
  <div class="wrapper">

    <div v-if="SearchersNameShowed()">

      <div class="container mobile_only">
        <Flick :options="{moveType:'freeScroll',bound: true,autoResize: true,autoInit: true}">
          <div v-for="(val, index) in getSearchSystems()" :key="index"
               class="search__icon icon_full">
            <img
                :src="search_systems[val].icon || `https://favicon.yandex.net/favicon/v2/${val}.com?size=32&stub=1`"
            >
            <p>{{val}}</p>
          </div>
        </Flick>
      </div>

    </div>

    <div :class="{'search__head__wrapper':true,'blured': blurHead}" style="display: flex" v-if="$route.query.search">
      <div class="no-margin" style="z-index: 1">
        <div class="row" style="margin-left: 20px">
          <div class="col-xs-12">
            <div class="search__head">
              <div>
                <a href="/"><img style="margin-right: 10px" src="https://netwiz.ru/local/templates/main/img/all_projects/netwiz1-removebg-logo.png" alt="Netwiz"></a>
                <a href="/search/"><img src="https://netwiz.ru/local/templates/main/img/all_projects/netwiz1-removebg-search-icon.png" alt="Поиск"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="head__services desktop_only">
        <div class="head__service" v-for="service of headerServices" :key="service.name">
          <img :src="service.img"><a :href="service.href">{{ service.name }}</a>
        </div>
      </div>
    </div>

    <div
        :class="['content',this.inputFocused ? 'mobile_tall' : '']"
        :style="(!$route.query.search) ? 'max-width: none' : ''">
      <div class="search-field" :style="(!$route.query.search) ? 'margin: 0 auto;max-width:700px;padding-top: 30px' : 'max-width:700px;'">
        <div class="search__content">

          <SearchForm
              @submit="onSearchSubmit"
              v-model="searchInput"
              @input="onSearchInput"
              @focusin="onInputFocusin"
              @focusout="onInputFocusOut"
          />

          <div v-if="$route.query.search">
            <ul class="search__services" >
              <li class="service__name"><a href="#">Главная</a></li>
              <li class="service__name"><a href="#">Картинки</a></li>
              <li class="service__name"><a href="#">Видео</a></li>
              <li class="service__name"><a href="#">Товары</a></li>
              <li class="service__name"><a href="#">Новости</a></li>
              <li class="service__name"><a href="#">Соц сети</a></li>
            </ul>
          </div>
          <div v-else class="banner_text">
            <a v-for="(service,index) in services" :key="index" class="thumb shine" :href="service.href" target="_blank">
              <img :src="service.img" :alt="service.name" draggable="false">
              <span>{{ service.name }}</span>
            </a>
          </div>

        </div>
      </div>
      <div :class="{'search-content':true,'blured':blurHead}">
        <div class="content__type content__type_search">
          <div class="content__content" v-if="showContent && getSearchContent.length">

            <div>
              <div class="sort__wrapper">
                <span style="color:#48578e;margin: 5px;cursor:pointer;user-select: none;text-decoration: none" @click="changeOrder">
                  <span style="border-bottom: 1px dashed #444;" v-if="!orderByRating">По популярности</span>
                  <span style="border-bottom: 1px dashed #444;" v-if="orderByRating">По рейтингу</span>
                </span>
              </div>
            </div>

            <div v-for="(item, index) in getSearchContent" :key="item.link">
              <type-search :icons_override="{'bing':'https://netwiz.ru/local/templates/main/assets/img/bing32.png'}"
                           :content="item"
                           :key="item.link"
                           :positions="item.positions"
                           :thumbnail="item.thumbnail"
                           v-if="index < counter">
              </type-search>

              <div class="ads" v-if="index === 2 && content.ads.length">
                <div class="ads__title">
                  <h3>Реклама</h3>
                  <a href="/pay" class="ads__subtitle">Продвигать свой домен</a>
                </div>
                <div class="ads__content">
                  <div class="ads__wrapper">
                    <slick ref="slick" :options="slickOptions">
                      <div class="ads__item" v-for="(ads,i) in getAdvertisements" :key="i">
                        <div class="ads__wrap">
                          <div class="content__top">
                            <img :src="`https://favicon.yandex.net/favicon/v2/${ads.link}?size=16&stub=1`">
                            <div class="adss__link">
                              <a :href="ads.link" target="_blank">
                                {{ getDisplayedLink(ads.displayed_link) }}
                              </a>
                            </div>
                          </div>
                          <div class="ads__text">
                            <a :href="ads.link" target="_blank">
                              {{ ads.title }}
                            </a>
                          </div>
                          <div class="ads__snippet">
                            {{ ads.snippet || ads.description }}
                          </div>

                        </div>
                      </div>
                    </slick>
                  </div>
                </div>
              </div>

            </div>

            <button class="counter" v-if="counter < getSearchContent.length" @click="counter = counter+10">
              Показать еще
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import _ from 'lodash'
import TypeSearch from "../components/search/TypeSearch";
import SearchForm from "@/components/SearchForm";
import Slick from 'vue-slick';
import Flick from "@/components/Sliders/Slick"
import Services from "@/data/services.json";
import HeaderServices from "@/data/header_services.json";
import Cache from "../cache";
import AdsSlickOptions from "@/data/adsSlickOptions"

export default {
  name: 'Home',
  data() {
    return {
      services: Services,
      headerServices: HeaderServices,
      counter: 10,
      slickOptions: AdsSlickOptions,
      searchInput: "",
      blurHead: false,
      inputFocused: false,
      search_systems: {
        'yandex': {
          pages: 2,
          items_per_page: 10,
        },
        'google': {},
        'bing': {
          icon: "https://netwiz.ru/local/templates/main/assets/img/bing32.png"
        },
        'duckduckgo': {},
        'yahoo': {}
      },
      content: {
        img: [],
        search: [],
        ads: [],
      },
      orderByRating: false,
      showContent: false,
      type: 'default',
      cachedQueries: new Cache("query"),
      queryHash: null,
    }
  },
  head: {
    title() {
      return {
        inner: this.searchInput ? this.searchInput + ' - Netwiz' : 'Поиск'
      }
    }
  },
  computed: {
    getAdvertisements(){
      return _.map(_.groupBy(this.content.ads,'displayed_link'),(item)=>item[0])
    },
    getQuerySearch() {
      return this.$route.query.search
    },
    getSearchContent() {
      if (this.content.search.length) {
        let arr = this.content.search
        for (let val of arr) {
          let avg = []
          for (let v of val.positions) {
            avg.push(v.pos)
          }
          val.avg = _.mean(avg) / this.getSearchSystems().length / avg.length
        }
        if (this.orderByRating) {
          return _.sortBy(arr, ['avg'])
        } else {
          const max_len = arr.reduce((p,c) => p.positions.length > c.positions.length ? p : c).positions.length;
          const sort_array = [];

          for(let i = max_len + 1;i-->1;) {
            const sorted_arr = arr.filter(item=>item.positions.length === i);
            if(sorted_arr.length > 0)
              sort_array.push(sorted_arr);
          }

          const final_arr = [];
          for(let s_arr of sort_array){
            s_arr = _.sortBy(s_arr,'avg');
            final_arr.push(...s_arr);
          }
          return final_arr;
        }
      } else {
        return []
      }
    },
    getImagesBySearch() {
      if (this.content.img.length) {
        return this.content.img;
      } else {
        return []
      }
    }
  },
  methods: {

    onInputFocusin(){
      this.blurHead = true;
      this.inputFocused = true;
    },

    onInputFocusOut(){
      this.blurHead = false;
      this.inputFocused = false;
    },

    onSearchInput(text){
      this.searchInput = text;
    },

    getLocation(){
      return window.location.pathname;
    },

    SearchersNameShowed(){
      return !document.body.classList.contains('search');
    },

    getSearchSystems() {
      return Object.keys(this.search_systems);
    },

    loadImagesContent(images) {
      this.content.img.push(...images);
    },

    async pathSiteTitleAndSnippet(site){
      const metas = await this.getMetaTags(site.link);
      if(metas){

        const new_title = metas["og:title"] || metas["title"] || metas["twitter:title"] || metas["lh_page_title"] || site.title;
        const new_snippet = metas["og:description"] || metas["description"] || site.snippet;
        const thumbnail = metas["twitter:image"] || metas["og:image"] || metas["thumbnail"] || site.thumbnail;

        site.title = (!site.title) || site.title.length < new_title.length ? new_title : site.title;
        site.snippet = (!site.snippet) || site.title.length < new_snippet.length ? new_snippet : site.snippet;
        site.thumbnail = thumbnail;
      }

      if(site.title){
        site.title = site.title.replaceAll("...","");
        site.title = site.title.replaceAll("…","");
      }

      if(site.snippet){
        site.snippet = site.snippet.replaceAll("...","");
        site.snippet = site.snippet.replaceAll("…","");
      }
    },
    loadSearchContent(data,position_offset=1) {
      const promises = [];
      for(let i = 0;i < data.length;i++){

        const val = data[i];
        val.link = val.link.toLocaleLowerCase();

        const find = _.findIndex(this.content.search, item => {
          return item.link === val.link
        })

        if (find === -1) {
          val.positions = []
          // val.positions[val.search] = i + 1
          val.positions.push({
            name: val.search,
            pos: i + position_offset
          })

          this.content.search.push(val)
          promises.push(this.pathSiteTitleAndSnippet(val));
        } else {

          if(val.snippet.indexOf("...") === -1 && val.snippet.indexOf("…") === -1){
            this.content.search[find].snippet =
                val.snippet.length > this.content.search[find].snippet.length ?
                    val.snippet : this.content.search[find].snippet;
          }

          if(val.title.indexOf("...") === -1 && val.title.indexOf("…") === -1){
            this.content.search[find].title =
                val.title.length > this.content.search[find].title.length ?
                    val.title : this.content.search[find].title;
          }

          this.content.search[find].positions.push({
            name: val.search,
            pos: i + position_offset
          })
        }
      }

      return promises;
    },

    async loadPage(url,page_options=null) {
      const resp = await axios.get(url)
      if (resp.status === 200 && page_options.hash === this.queryHash) {

        const data = _.filter(resp.data,(item,i)=>{
          return !isNaN(+i);
        })

        const images = _.filter(data, item => item.type === 'img')
        if (images.length) {
          this.loadImagesContent(images)
        }
        const ads = _.filter(data, item => item.type === 'ads')
        if (ads.length) {
          for (let item of ads) {
            this.content.ads.push(item)
          }
        }
        const search = _.filter(data, item => item.type === 'search')
        if (search.length) {
          let arr = []
          search.map(item => {
            if (item.link.indexOf('yabs.yandex') === -1) {
              arr.push(item)
            } else {
              this.content.ads.push(item)
            }
          })
          let position_offset = 1;
          if(page_options && page_options.items_per_page){
            position_offset += page_options.page * page_options.items_per_page;
          }
          return this.loadSearchContent(arr,position_offset)
        }
      }
      return [];
    },
    async loadData() {
      const cached = this.cachedQueries.get(this.searchInput);

      if(cached){
        this.content = cached;
        this.showContent = true;
        console.log("request "+this.searchInput+" loaded from cache");
        return;
      }

      this.showContent = false;
      this.content.ads = [];

      let total_page_loaded = 0;
      let needed_to_load = 0;
      for(const search_sys in this.search_systems){
        needed_to_load += this.search_systems[search_sys].pages || 1;
      }
      const promises = [];

      const onPageLoaded = (force_draw = false,addictional_promises = []) => {
        promises.push(...addictional_promises);
        if(force_draw){
          this.showContent = true;
        }

        if(++total_page_loaded >= needed_to_load){
          Promise.all(promises).then(()=>{
            console.log("Кэширую запросы");
            this.cachedQueries.put(this.searchInput,this.content);
          })
          this.showContent = true;
        }
      }

      try {
        document.title = this.searchInput + ' - Netwiz';

        for (const item of this.getSearchSystems()) {
          const search_system = this.search_systems[item];
          if(search_system.pages){

            if(!search_system.items_per_page)
              console.error("Задана пагинация,но не задано свойство [items_per_page] у поисковой системы "+item);

            for(let page = 0;page < search_system.pages; page++){
              this.loadPage(
                  `https://netwiz.ru/ajax/${item}_search.php?p=${page}&search=${this.searchInput}`,
                  {page:page,items_per_page: search_system.items_per_page,hash: this.queryHash}
              ).then((prom) => onPageLoaded(true,prom))
                  .catch((e) => {
                    console.error(e);
                    onPageLoaded(true);
                  })
            }

          }else {
            this.loadPage(
                `https://netwiz.ru/ajax/${item}_search.php?search=${this.searchInput}`,
                {hash: this.queryHash}
            )
                .then((prom) => onPageLoaded(true,prom))
                .catch(() => onPageLoaded(true))
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSearchLang() {
      return /[а-я]/i.test(this.searchInput) ? 'ru' : 'en'
    },
    getDisplayedLink(link) {
      if (link.indexOf('›') !== -1) {
        link = link.split('›')[0]
      }
      if (link.indexOf('http') !== -1) {
        link = link.split('/')[2]
      }
      // убираем www.
      link = link.replace("www.", "");
      // убираем домен
      {
        const match = link.match(/(.+)\.(com|ru)/);
        if (match) {
          link = match[1];
        }
      }
      return link;
    },
    changePage() {
      this.$router.push({
        query: {
          search: this.searchInput
        }
      })
    },
    changeOrder() {
      this.orderByRating = !this.orderByRating;
    },

    onSearchSubmit() {
      this.changePage()
    },

    async getMetaTags(url){
      const axinst = axios.create({
        baseURL:'https://netwiz.ru/ajax/meta_tags.php?url='+encodeURIComponent(url),
        timeout: 20000,
      })
      try{
        const resp = await axinst.get('');
        if (resp.status === 200 && resp.data) {
          return resp.data;
        }
      }catch (e) {
        return [];
      }
    },
  },
  watch: {
    blurHead() {
      let el = document.getElementsByClassName('ex')
      if (el.length) {
        el = el[0]
        if (this.blurHead) {
          el.classList.add('blur')
        } else {
          el.classList.remove('blur')
        }
      }

    },
    getQuerySearch() {
      this.counter = 10
      this.queryHash = Math.floor(Math.random()*999999);
      this.content = {
        search: [],
        img: [],
        ads: []
      }
      this.searchInput = this.$route.query.search

      if (this.searchInput) {
        this.loadData()
        document.body.classList.add('search')
      } else {
        document.body.classList.remove('search')
      }
    },
  },
  created() {
    if(this.$route.query.search !== undefined){
      document.body.classList.add('search')
      this.searchInput = "";
    }
    if (this.$route.query.search) {
      this.searchInput = this.$route.query.search
    }

    const search_override_block = document.querySelector("[data-term]");
    if(search_override_block) {
      this.searchInput = search_override_block.getAttribute("data-term")
    }
  },
  mounted() {

    if(this.searchInput){
      this.loadData();
    }

  },
  components: {
    TypeSearch,
    Slick,
    Flick,
    SearchForm
  },
}
</script>

<style lang="scss">

.blured{
  filter: blur(10px) !important;
}

@media screen and (max-width: 768px) {
  .desktop_only {
    display: none !important;
  }
  .mobile_tall{
    min-height: 100vh;
  }
}
@media screen and (min-width: 769px) {
  .mobile_only {
    display: none !important;
  }
}


#app {
  h1,h2,h3,h4,h5,a,p,b,span{
    font-family: "Montserrat", sans-serif !important;
  }
  font-family: "Montserrat", sans-serif !important;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  select:focus,
  .input__compact textarea:focus {
    font-size: 16px !important;
  }
}

.ex.index{
  padding-bottom: 5px !important;
}

.no-margin {
  margin: 0 !important;
}

.counter {
  margin-top: 24px;
  margin-bottom: 24px;
  background: linear-gradient(
          to right,
          rgba(170, 170, 255, 1) 50%,
          rgba(34, 187, 255, 1)
  );
  color: #fff;
  border: none;
  font-size: 18px;
  height: 40px;
  padding: 0 20px;
  cursor: pointer;
}

.search .head__services {

  display: flex;
  width: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  .head__service {

    display: flex;
    align-items: center;

    margin-top: 10px;

    a{
      text-decoration: none;
      font-size: 18px;
      color: black;
      margin: 0 10px;
    }

    a:hover{
      text-decoration: underline;
    }

    img {
      height: 20px;
      border-radius: 5px;
    }
  }

}

.search .search__head__wrapper{

  transition: filter .2s ease-in-out;
  position: relative;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    justify-content: center;
    padding: 10px;
  }
}

.search .search__head {

  @media screen and (max-width: 480px){
    &{
      justify-content: center;
      transform: scale(0.8);
    }
  }

  text-align: left;
  font-size: 30px;
  padding: 0 20px 0;
  display: flex !important;
  justify-content: space-between;
  align-items: center;

  img {
    max-height: 30px;
    height: 100%;
  }

  @media screen and (max-width: 992px) {
    text-align: left !important;
  }

  svg {
    width: 100%;
    max-width: 400px;
    height: auto;
  }
}

.slick-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 32px;
  height: 32px;
  border-radius: 10em;
  border: none;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    vertical-align: top;
  }

  &.slick-prev {
    left: -20px;

    svg {
      position: relative;
      left: -2px;
    }
  }

  &.slick-next {
    right: -20px;

    svg {
      transform: rotate(180deg);
    }
  }

  &.slick-disabled {
    display: none;
  }
}

.slick-list {
  overflow: hidden;
}

.slick-track {
  display: flex;
}

.sort__button{
  margin: 10px 10px;
  cursor: pointer;
  border: 1px solid #99cbf3;
  padding: 10px 10px;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.3);
}

.sort__wrapper{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  span {
    font-size: 16px;
  }
}

.ads {
  background: #fff;
  padding: 10px 0;
  margin-bottom: 5px;
}

.ads__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  padding: 0 10px;
  margin: 0;
  width: 100%;

  h3 {
    margin: 0;
  }
}

.ads__subtitle {
  font-size: 13px;
}

.ads__content {
  padding-top: 10px;
  text-align: left;
  position: relative;
  .slick-track {
    display: flex;
    align-items: stretch;
  }
  .slick-slide {
    display: flex !important;
    align-items: stretch;

    & > div {
      height: 100%;
    }
  }
}

.ads__item {
  padding: 10px;
  box-sizing: border-box;
  /*margin-right: 20px;*/
  min-height: 220px;
  display: flex !important;
  align-items: stretch;
}

.ads__wrap {
  background-color: lighten(#000, 98%);
  padding: 10px;
  /*height: 100%;*/
  border-radius: 10px;
}

.ads__snippet {
  font-size: 12px;
  padding-top: 5px;
  line-height: 1.3;
  max-height: 8.5rem;
  overflow: hidden;
}

.ads__text{
  max-height: 5rem;
  overflow: hidden;
  font-size: 16px;

  a {
    text-decoration: none;
    color: navy;
    font-weight: bold;
  }
}

.adss__link {
  color: black;
  padding: 10px 0 10px 10px;
  user-select: text;
  text-decoration: none;
}

.adss__link a {
  text-decoration: none !important;
}

.search {
  &-field {
    margin-left: 20px;
    max-width: 50%;
    position: relative;
    transition: all 0.25s;
    padding: 60px 0 10px;

    @media screen and (max-width: 768px) {
      padding: 0 !important;
      max-width: 640px;
      margin: 0;
    }
  }

  &-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    transition: filter 0.2s ease-in-out;
  }

  &__top {
    font-weight: bold;
    text-align: center;
    padding-left: 5px;
    padding-bottom: 15px;
  }

  &__text {
    padding-top: 15px;
  }

  //background: #fff;
  //background-color: #fff;
  &__content {
    max-width: 1100px;
    margin: 0 auto;
    position: relative;
  }

  &__services{

    .service__name:before{
      display: none;
    }

    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    justify-content: space-evenly;

    .service__name{
      padding-left: 0;
    }

    .service__name a{
      font-size: 14px;
      color: black;
      text-decoration: none;
    }

  }

  &__icons {
    //position: absolute;
    right: 100%;
    max-width: 100%;
    margin: 0;
    width: 100%;
    padding: 0;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-items: center;
    top: 50%;
    list-style-type: none;
    //transform: translateY(-50%);
    /*padding-top: 15px;*/
    @media screen and (max-width: 768px) {
      //right: 50%;
      left: 0;
      top: 100%;
      padding-right: 0;
      padding-top: 10px;
      transform: translateX(0);
    }
  }

  &__icons_under_banner {
    justify-content: flex-end;

    .search__icon{
      margin: 10px !important;
    }

    @media screen and (max-width: 992px){
      justify-content: space-between;
    }
  }

  &__icon {
    margin: 10px 10px;
    /*height: 65px;*/
    width: auto;
    border: 1px solid #99cbf3;
    padding: 5px;
    border-radius: 10px;
    background-size: 88% !important;
    background-position: center !important;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 5px 5px 10px 0px rgba(#000, 0.3);

    p {
      display: none;
    }

    .mobile_only &.icon_full{
      display: flex !important;
    }

    &.icon_full{
      margin: 10px 2px;

      p {
        user-select: none;
        display: block;
        margin: 0 5px;
      }
      img {
        max-height: 25px;
      }
    }
  }

  &__predictors {
    position: absolute;
    z-index: 1000;
    top: calc(100% + 5px);
    left: 0;
    right: 0;
    background-color: #fff;
    margin: 0;
    padding: 3px;
    list-style-type: none;
    text-align: left;
    border-radius: 10px;
    overflow: hidden;

    div {
      border-radius: 10px;
      padding: 10px;
      cursor: pointer;
      //transition: all .25s;
      background: transparent;

      &.active {
        background: linear-gradient(
                to right,
                rgba(170, 170, 255, 1) 50%,
                rgba(34, 187, 255, 1)
        );
        color: #fff;
      }
    }
  }

  &__wrapper {
    background: linear-gradient(
            to right,
            rgba(170, 170, 255, 1) 50%,
            rgba(34, 187, 255, 1)
    );
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    border-radius: 15px;
    //overflow: hidden;
    max-width: 1000px;
    //padding: 1px;
    position: relative;
    transition: all 0.25s;

    @media screen and (max-width: 768px) {
      margin-left: 10px;
      margin-right: 10px;
    }

    &.active {
      @media screen and (max-width: 768px) {
        max-width: 100%;
      }
    }

    &.active.input_focused .search__input_wrapper {
      max-width: calc(100% - 50px);
    }
  }

  &__input_cancel_button {
    margin: 5px;
    cursor: pointer;
    user-select: none;
  }

  &__input {
    line-height: 18px;
    border: 0;
    font-size: 18px;
    outline: none;
    width: 100%;
    resize: none;
    background: none !important;
    white-space: nowrap;
    //font-weight: bold;
  }

  &__input::placeholder{
    text-align: center;
  }

  &__input::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  &__input_wrapper.input__compact {
    height: 50px;
  }

  &__input_wrapper.input__compact .search__input {
    font-size: 14px;
    white-space: pre-wrap;
  }

  &__input_wrapper .search__input::-webkit-scrollbar {
    display: none;
  }

  &__input_wrapper {
    display: flex;
    align-items: center;

    transition: all 0.5s ease-in-out;
    height: 40px;
    padding: 0 10px;
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    z-index: 3;
    border: 1px solid #99cbf3;
    max-width: 1000px;
    font-family: Montserrat, sans-serif;
    background: white;
  }

  &__button {
    font-size: 18px;
    height: 100%;
    border: none;
    width: 90px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    //background: none;
    margin-left: -10px;
    margin-right: 10px;
    padding-left: 49px;
    z-index: 1;
    background: linear-gradient(
            to right,
            rgba(170, 170, 255, 1) 50%,
            rgba(34, 187, 255, 1)
    );
    color: #fff;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.25s;
    opacity: 1;
    border-radius: 15px;

    svg {
      width: 30px;
      height: auto;

      * {
        fill: #fff;
      }
    }

    &.active {
      right: 0;
    }
  }
}

.content {
  max-width: 1190px;
  box-sizing: border-box;
  //margin: 0 auto;

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }

  &__type {
    &_search {
      max-width: 700px;
      width: 100%;
      padding-left: 30px;
      @media screen and (max-width: 768px) {
        padding-left: 0;
      }
    }
  }

  &__right {
    width: 100%;
    padding-left: 30px;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &__disp {
    font-size: 12px;
    color: #006000;
    padding: 10px 0;
  }

  &__top {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      font-size: 14px;
      padding-left: 10px;
    }

    a {
      text-decoration: none;
      color: #000;
    }
  }

  &__favicon {
    @media screen and (max-width: 768px) {
      left: 10px;
      top: 10px;
    }
  }

  &__image {
    min-width: 200px;
    max-width: 200px;
    padding-right: 10px;

    img {
      width: 100%;
      height: auto;
      vertical-align: top;
    }
  }

  &__link {
    color: #006000;
    text-decoration: none;
    font-size: 14px;
    padding-top: 5px;
  }

  &__title {
    line-height: 1.2 !important;
    font-size: 0.98em;
    margin: 5px 0;
    max-height: 4.5rem;
    overflow: hidden;
    a {
      text-decoration: none;
      color: navy;
    }
  }

  &__desc {
    max-height: 8.5rem;
    overflow: hidden;
    line-height: 17px;
    color: #000;
  }

  &__type {
    //padding-top: 10px;

    img {
      vertical-align: middle;
    }
  }

  &__images {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
}

.masonry-container .item {
  max-width: 180px;
}

.icon_full img {
  max-width: none;
}

</style>
